import { useEventListener } from './useEventListener';
export var EventListener = /*#__PURE__*/function () {
  function EventListener(props) {
    useEventListener(props);
    return null;
  }

  EventListener.defaultProps = {
    capture: false
  };
  return EventListener;
}();
//# sourceMappingURL=EventListener.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@fluentui/react-component-event-listener/dist/es/EventListener.js
// module id = 1785
// module chunks = 0